import { RelativeDirection, RelativeUnit } from '../../../../../apis/graphql/types';

export const RELATIVE_DIRECTION_LABELS: Record<RelativeDirection, string> = {
  [RelativeDirection.Past]: 'Past',
  [RelativeDirection.Next]: 'Next',
  [RelativeDirection.This]: 'This',
};

const RELATIVE_UNIT_SINGULAR: Record<RelativeUnit, string> = {
  [RelativeUnit.Day]: 'Day',
  [RelativeUnit.Week]: 'Week',
  [RelativeUnit.Month]: 'Month',
  [RelativeUnit.Quarter]: 'Quarter',
  [RelativeUnit.Year]: 'Year',
};

export const RELATIVE_DIRECTION_ORDER: RelativeDirection[] = [
  RelativeDirection.Past,
  RelativeDirection.Next,
  RelativeDirection.This,
];

export const RELATIVE_UNIT_ORDER: RelativeUnit[] = [
  RelativeUnit.Day,
  RelativeUnit.Week,
  RelativeUnit.Month,
  RelativeUnit.Quarter,
  RelativeUnit.Year,
];

/** THIS is always singular; PAST/NEXT pluralize on anything but 1. All units are regular. */
export const getUnitLabel = (unit: RelativeUnit, value: number | null, direction: RelativeDirection): string => {
  const singular = RELATIVE_UNIT_SINGULAR[unit];
  if (direction === RelativeDirection.This || value === 1) return singular;
  return `${singular}s`;
};

/** The phrase the three controls read as — "Next 4 Months", "This Quarter". Shared with the chip. */
export const getRelativeExpression = (
  direction: RelativeDirection,
  value: number | null,
  unit: RelativeUnit
): string => {
  const directionLabel = RELATIVE_DIRECTION_LABELS[direction] ?? direction;
  const unitLabel = getUnitLabel(unit, value, direction);
  return direction === RelativeDirection.This
    ? `${directionLabel} ${unitLabel}`
    : `${directionLabel} ${value ?? ''} ${unitLabel}`.replace(/\s+/g, ' ').trim();
};

export const getUnitOptionLabel = (unit: RelativeUnit): string => `${RELATIVE_UNIT_SINGULAR[unit]}(s)`;
